const _pad = (n) => String(n).padStart(2, "0");

export const getTodayFormatted = () => {
  const d = new Date();
  return `${d.getFullYear()}-${_pad(d.getMonth() + 1)}-${_pad(d.getDate())}`;
};

// Affiche "DD/MM/YYYY" à partir d'une ISO string ou "YYYY-MM-DD ..."
// Les chaînes date seule (YYYY-MM-DD) sont parsées à midi local pour éviter
// le décalage d'un jour lié à minuit UTC.
export const formatDateShort = (dateStr) => {
  if (!dateStr) return "—";
  const d = new Date(dateStr.includes("T") ? dateStr : `${dateStr}T12:00:00`);
  if (isNaN(d)) return dateStr;
  return d.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" });
};
